namespace TabAurous.Inventory {
    export interface SortingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherNo?: string;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: SortingDetailsRow[];
        DetailItems?: SortingItemsRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        NewProductId?: number;
        ItemTypeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        SieveId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        Pieces?: number;
        Weight?: number;
        NewPieces?: number;
        NewWeight?: number;
        NetWeight?: number;
        LotNo?: string;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        GenerateLot?: string;
        Clear?: string;
        Rate?: number;
        Username?: string;
    }

    export namespace SortingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.Sorting';
        export const deletePermission = 'Inventory:Sorting:Delete';
        export const insertPermission = 'Inventory:Sorting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Sorting:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            DetailItems = "DetailItems",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            NewProductId = "NewProductId",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            Pieces = "Pieces",
            Weight = "Weight",
            NewPieces = "NewPieces",
            NewWeight = "NewWeight",
            NetWeight = "NetWeight",
            LotNo = "LotNo",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            GenerateLot = "GenerateLot",
            Clear = "Clear",
            Rate = "Rate",
            Username = "Username"
        }
    }
}
